import { render, staticRenderFns } from "./ConfigParamsContextMenu.vue?vue&type=template&id=10f8ceba&"
import script from "./ConfigParamsContextMenu.vue?vue&type=script&lang=js&"
export * from "./ConfigParamsContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f8ceba')) {
      api.createRecord('10f8ceba', component.options)
    } else {
      api.reload('10f8ceba', component.options)
    }
    module.hot.accept("./ConfigParamsContextMenu.vue?vue&type=template&id=10f8ceba&", function () {
      api.rerender('10f8ceba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ConfigParamsContextMenu.vue"
export default component.exports